import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState } from './config';

import { InvoiceDataContext } from '../../contexts/InvoiceData';

import useRepairsStore from '../../store/repairs';

import useInvoiceActionStore from '../../store/invoice_actions';

import Sidebar from './Components/Sidebar';

import { isEmpty } from 'lodash';


const EditRepairTicket = ({ dialog = false }) => {

  const [ formFields, setFormFields ] = useState([...fields.map(field => ({...field}))]);
  const [ initValues, setInitValues ] = useState(initialValues);
  const [ invoice, setInvoice ] = useState({});

  // const setPendingRepairsDialog = useRepairsStore((state) => state.setPendingRepairsDialog);
  // const invoice_data = useRepairsStore((state) => state.invoice_data);
  // const setInvoiceData = useRepairsStore((state) => state.setInvoiceData);

  const setPendingIADialog = useInvoiceActionStore((state) => state.setPendingIADialog);
  const invoice_data = useInvoiceActionStore((state) => state.invoice_data);
  const setInvoiceData = useInvoiceActionStore((state) => state.setInvoiceData);

  useEffect(() => {
    if (invoice_data?.invoice_id) {
      setInvoice(invoice_data);
      setInvoiceData({});
      // setPendingRepairsDialog(null)
      setPendingIADialog(null)
    }
  }, [invoice_data]);

  const additionalButtons = isEmpty(invoice) ? [
    { text: "Save & Close", variant: "outlined", color: "primary", icon: <SaveRoundedIcon />, forceClose: true, redirect: `/repair_tickets/`},
    { text: "Save & Add Repairs", variant: "contained", color: "primary", icon: <ArrowForwardRoundedIcon />, redirect: null}
  ] : [{ text: "Save Repairs", variant: "contained", color: "primary", icon: <SaveRoundedIcon />, forceClose: true, redirect: null}]

  return (
    <InvoiceDataContext.Provider value={{ invoice_data: invoice }}>
      <EditForm title={"Repair"} initialValues={initValues} fields={formFields} schema={schema} additionalState={additionalState} url={"repair_tickets"} dialog={true} loadOnDialog={!dialog} additionalButtons={additionalButtons} submitButton={true} update_fields={["invoice_id"]} invalidate_queries={[["invoices"]]} sidebar={<Sidebar />} show_progress={true}>
        
      </EditForm>
    </InvoiceDataContext.Provider>
  );
}

export default EditRepairTicket;

// const setPendingRepairsDialog = useRepairsStore((state) => state.setPendingRepairsDialog);